import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=7bd83ae0&scoped=true&lang=html&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=7bd83ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd83ae0",
  null
  
)

component.options.__file = "Contact.vue"
export default component.exports